module.exports = __webpack_public_path__ + "img/tab-bg2.5f319d85.png";